import React, { Fragment } from 'react'
import { useEffect } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import actions from 'redux/actions'
import { links } from 'common/helpers'

import Row from 'components/_new/layout/Row/Row'
import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'

import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import QueueContainer from 'layouts/SubscriptionLayout/QueueContainer/QueueContainer'

import messages from './messages'


const QueueSection = ({ closeMenu }) => {
  const { isLoaderVisible } = useConnect((state) => state.models.queue.isFetching || !state.models.queue.isFetched)

  useEffect(() => {
    actions.models.queue.fetch()
  }, [])

  return (
    <Fragment>
      <Box pt="12" pb="12" pl="16">
        <Row>
          <Text message={messages.queue} size="28-40" semibold />
          <Button
            title={messages.manage}
            to={links.queue}
            size="sm"
            color="brandTransparent"
            onClick={closeMenu}
          />
        </Row>
      </Box>
      <ContentWithLoader isFetching={isLoaderVisible}>
        <QueueContainer placement="mobile profile menu" />
      </ContentWithLoader>
    </Fragment>
  )
}


export default QueueSection
